import { render, staticRenderFns } from "./UserCenterTop.vue?vue&type=template&id=9638e734&scoped=true&"
import script from "./UserCenterTop.vue?vue&type=script&lang=js&"
export * from "./UserCenterTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9638e734",
  null
  
)

export default component.exports